import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Letters from "./Letters";

function LetterContainer(props) {
  return (
    <Col>
      <Row>
        <div style={{ textAlign: "center" }}>
          {props.letters.map((letter) => (
            <Letters key={letter.id} id={letter.id} name={letter.letter} />
          ))}
        </div>
      </Row>
    </Col>
  );
}

export default LetterContainer;
